import React from 'react';
import { FaArrowDown, FaArrowUp } from 'react-icons/fa';

import { CardKpi } from './styles';
import { WidgetKpi } from '../../types/Dashboard';
import { formatarValor } from '../../utils/formatadores';

// Número de destaque. O valor fica na cor do texto; o tom vem como ícone + cor de status (nunca só a cor).
export default function KpiCard({ widget }: { widget: WidgetKpi }) {
  const valor = formatarValor(widget.valor, widget.formato);

  return (
    <CardKpi>
      <span className='titulo'>
        {widget.tom === 'positivo' && <FaArrowUp size={10} className='positivo' aria-label='positivo' />}
        {widget.tom === 'negativo' && <FaArrowDown size={10} className='negativo' aria-label='atenção' />}
        {widget.titulo}
      </span>
      <span className='valor' title={valor}>{valor}</span>
      {widget.detalhe && <span className='detalhe'>{widget.detalhe}</span>}
    </CardKpi>
  );
}
